// Inertia
import { Link } from '@inertiajs/vue3';

// Components
import Alert from '@components/Shared/Alert/Alert.vue';
import Badge from '@components/Shared/Badge/Badge.vue';
import Button from '@components/Shared/Button/Button.vue';
import Icon from '@components/Shared/Icon.vue';
import Accordion from '@components/Shared/Accordion/Accordion.vue';
import AccordionItem from '@components/Shared/Accordion/AccordionItem.vue';
import AccordionLink from '@components/Shared/Accordion/AccordionLink.vue';
import Input from '@components/Shared/Input.vue';

// Global Method$
import { useRouter, usePrice, useDevice } from '@composables';

export default {
	install(app) {
		// Inertia
		app.component('Link', Link);

		// Components
		app.component('Alert', Alert);
		app.component('Badge', Badge);
		app.component('Button', Button);
		app.component('Icon', Icon);
		app.component('Accordion', Accordion);
		app.component('AccordionItem', AccordionItem);
		app.component('AccordionLink', AccordionLink);
		app.component('Input', Input);

		// Global Methods
		// $route: route wrapper with subdomain
		const { toRoute } = useRouter();
		app.config.globalProperties.$route = (name, params = {}) => toRoute(name, params);

		// $toEuro: format number to euro
		const { toEuro } = usePrice();
		app.config.globalProperties.$toEuro = (value) => toEuro(value);

		// $isDevice: js boolean for device breakpoint
		app.config.globalProperties.$isMobile = useDevice().isMobile;
		app.config.globalProperties.$isLaptop = useDevice().isLaptop;
	},
};
